import { ADD_LANGUAGE } from '../mutation-types'

const state = {
  languages: []
}

const getters = {
  getLanguageFromDescription: (state) => (description) => {
    let languageDescription = ''
    state.languages.forEach((language) => {
      languageDescription = language.description === description ? language.name : languageDescription
    })
    return languageDescription
  },
  getLanguageDescriptions: (state) => {
    return state.languages.map(x => x.description)
  }
}

const mutations = {
  [ADD_LANGUAGE] (state, language) {
    state.languages.push(language)
  }
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/language.js